(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["zorro-global-sale-bar"] && !Shopify.designMode) return;
  try {
    (function(){
    if(window.ZorroCampaign&&window.ZorroCampaign.version)return;
    var threshold=4000,lastCart=null,refreshTimer=null;
    function currency(amount){
      var code=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR';
      var locale=document.documentElement.lang||'en';
      try{return new Intl.NumberFormat(locale,{style:'currency',currency:code,minimumFractionDigits:2}).format(amount/100);}
      catch(error){return (amount/100).toFixed(2).replace('.',',')+' €';}
    }
    function updateCart(cart){
      if(!cart||typeof cart.total_price!=='number')return;
      lastCart=cart;
      document.querySelectorAll('[data-zorro-free-shipping]').forEach(function(node){
        var goal=Number(node.dataset.threshold||threshold),remaining=Math.max(0,goal-cart.total_price),unlocked=remaining===0;
        var template=unlocked?node.dataset.unlocked:node.dataset.remaining;
        var message=node.querySelector('[data-zfs-message]'),fill=node.querySelector('[data-zfs-fill]');
        if(message)message.textContent=(template||'').replace('%amount%',currency(remaining));
        if(fill)fill.style.width=Math.min(100,Math.max(0,cart.total_price/goal*100))+'%';
        node.classList.toggle('is-unlocked',unlocked);
      });
    }
    function refreshCart(){
      clearTimeout(refreshTimer);
      refreshTimer=setTimeout(function(){
        var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
        fetch(root+'cart.js',{cache:'no-store',headers:{Accept:'application/json'}}).then(function(response){return response.json();}).then(updateCart).catch(function(){});
      },80);
    }
    window.ZorroCampaign={version:'1.1',updateCart:updateCart,refreshCart:refreshCart};
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',refreshCart);else refreshCart();
    document.addEventListener('click',function(event){if(event.target.closest('.header__icon--cart,[href$="/cart"],[href*="/cart?"]'))setTimeout(refreshCart,180);});
    new MutationObserver(function(records){
      var addedProgress=records.some(function(record){
        return Array.prototype.some.call(record.addedNodes,function(node){
          return node.nodeType===1&&(node.matches('[data-zorro-free-shipping]')||node.querySelector('[data-zorro-free-shipping]'));
        });
      });
      if(addedProgress&&lastCart)updateCart(lastCart);
    }).observe(document.documentElement,{childList:true,subtree:true});
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zorro-gripsock-packs"] && !Shopify.designMode) return;
  try {
    (function () {
    var box = document.querySelector('#zorro-pp [data-zgs]');
    if (!box || box.dataset.ready) return;
    box.dataset.ready = '1';

    function json(sel, fallback) { var el = box.querySelector(sel); try { return JSON.parse(el.textContent); } catch (e) { return fallback; } }
    var tiers = json('[data-zgs-tiers]', []).filter(function (x) { return x && x.variants && x.variants.length; });
    var t = json('[data-zgs-copy]', {});
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var pairsEl = box.querySelector('[data-zgs-pairs]');
    function tier(n) { return tiers.find(function (x) { return x.n === n; }); }
    var single = tier(1);
    if (!single) return;
    var variants = single.variants;

    /* colours in first-seen order, sizes per colour */
    var colors = [];
    variants.forEach(function (v) { if (colors.indexOf(v.color) < 0) colors.push(v.color); });
    function sizesOf(color) { return variants.filter(function (v) { return v.color === color; }); }
    function variantOf(color, size) { return variants.find(function (v) { return v.color === color && v.size === size; }); }
    function colorKey(c) {
      c = c || '';
      if (/black|must/i.test(c)) return 'black';
      if (/blue|sinin/i.test(c)) return 'blue';
      if (/red|puna/i.test(c)) return 'red';
      return 'white';
    }
    /* sleeves come in one size: no size chips, pack titles name the colour only */
    var oneSize = variants.every(function (v) { return v.size === variants[0].size; });
    function colorName(c) { return t[colorKey(c)] || c; }
    function sizeShort(size) { var m = /^(.+?)\s*\((.+)\)$/.exec(size || ''); return m ? { a: m[1], b: m[2] } : { a: size, b: '' }; }
    function firstAvailable(color) { var list = sizesOf(color); return list.find(function (v) { return v.available; }) || list[0]; }
    function money(cents) { return '€' + (cents / 100).toFixed(2).replace('.', ','); }

    /* a bundle variant title "2× White S + 1× Black One size" names gripsocks
       variants by colour + short size; match on the counts, not the order */
    function label(v) { return oneSize ? v.color : v.color + ' ' + sizeShort(v.size).a; }
    function key(counts) { return Object.keys(counts).sort().map(function (k) { return counts[k] + '×' + k; }).join('|'); }
    tiers.forEach(function (tr) {
      if (tr.n === 1) return;
      tr.variants.forEach(function (v) {
        var counts = {};
        String(v.title).split(' + ').forEach(function (part) {
          var m = /^(\d+)\s*×\s*(.+)$/.exec(part.trim());
          if (m) counts[m[2]] = Number(m[1]);
        });
        v.key = key(counts);
      });
    });

    var start = variants.find(function (v) { return String(v.id) === box.dataset.start; }) || variants.find(function (v) { return v.available; }) || variants[0];
    var state = { n: tier(3) ? 3 : 1, pairs: [], allColor: start.color, allSize: start.size, open: false };
    function fill(n) {
      var keep = state.pairs.slice(0, n);
      while (keep.length < n) keep.push({ color: state.allColor, size: state.allSize });
      state.pairs = keep;
    }
    function current() {
      if (state.n === 1) return variantOf(state.pairs[0].color, state.pairs[0].size);
      var counts = {};
      state.pairs.forEach(function (p) { var v = variantOf(p.color, p.size); if (v) counts[label(v)] = (counts[label(v)] || 0) + 1; });
      var k = key(counts), tr = tier(state.n);
      return tr ? tr.variants.find(function (v) { return v.key === k; }) : null;
    }
    function packPrice() { var v = current(), tr = tier(state.n); return v ? v.price : tr.variants[0].price; }

    /* ---------- render ---------- */
    function swatches(idx, cur) {
      return '<div class="zgs-colors" role="radiogroup" aria-label="' + (idx < 0 ? t.all : t.pairLabel + ' ' + (idx + 1)) + '">' +
        colors.map(function (c) {
          var any = sizesOf(c).some(function (v) { return v.available; });
          return '<button type="button" class="zgs-sw' + (c === cur ? ' on' : '') + '" data-idx="' + idx + '" data-color="' + c + '" role="radio" aria-checked="' + (c === cur) + '" aria-label="' + colorName(c) + (any ? '' : ' · ' + t.soldOut) + '"' + (any ? '' : ' disabled') + '>' +
            '<span class="dot dot--' + colorKey(c) + '"></span></button>';
        }).join('') + '</div>';
    }
    function chips(idx, color, cur) {
      if (oneSize) return '';
      var list = sizesOf(color);
      return '<div class="zgs-sizes">' + list.map(function (v) {
        var s = sizeShort(v.size), only = list.length === 1;
        return '<button type="button" class="zgs-chip' + (v.size === cur ? ' on' : '') + (only ? ' is-only' : '') + '" data-idx="' + idx + '" data-size="' + v.size + '" aria-pressed="' + (v.size === cur) + '"' + (v.available ? '' : ' disabled') + '>' + s.a + (s.b ? ' <small>' + s.b + '</small>' : '') + '</button>';
      }).join('') + '</div>';
    }
    function row(idx, p, lbl, extra) {
      return '<li class="zgs-row' + (extra || '') + '"><span class="zgs-row-label">' + lbl + '</span>' + swatches(idx, p.color) + chips(idx, p.color, p.size) + '</li>';
    }
    function summary() {
      var counts = {}, order = [];
      state.pairs.forEach(function (p) { var k = oneSize ? colorName(p.color) : colorName(p.color) + ' ' + sizeShort(p.size).a; if (!counts[k]) { counts[k] = 0; order.push(k); } counts[k]++; });
      return order.map(function (k) { return '<b>' + counts[k] + '×</b> ' + k; }).join(' &nbsp;·&nbsp; ');
    }
    function render() {
      var n = state.n, html = '';
      if (n === 1) {
        html += '<ul class="zgs-rows">' + row(0, state.pairs[0], t.pairLabel + ' 1') + '</ul>';
      } else if (n <= 5) {
        html += '<div class="zgs-pairs-head"><b>' + n + ' × ' + t.pairsHead + '</b></div>';
        html += '<p class="zgs-note">' + t.pairsSame + '</p>';
        html += '<ul class="zgs-rows">' + state.pairs.map(function (p, i) { return row(i, p, t.pairLabel + ' ' + (i + 1)); }).join('') + '</ul>';
      } else {
        html += '<div class="zgs-pairs-head"><b>' + n + ' × ' + t.pairsHead + '</b></div>';
        html += '<ul class="zgs-rows">' + row(-1, { color: state.allColor, size: state.allSize }, t.all, ' zgs-row--all') + '</ul>';
        if (state.open) html += '<ul class="zgs-rows is-scroll">' + state.pairs.map(function (p, i) { return row(i, p, t.pairLabel + ' ' + (i + 1)); }).join('') + '</ul>';
        html += '<button type="button" class="zgs-toggle" data-zgs-toggle aria-expanded="' + state.open + '">' + (state.open ? t.hideEach + ' ▴' : t.editEach + ' ▾') + '</button>';
      }
      if (n > 1) html += '<p class="zgs-sum">' + summary() + '</p>';
      html += '<p class="zgs-error" data-zgs-error hidden></p>';
      pairsEl.innerHTML = html;
      prices();
      buttons();
    }

    /* ---------- prices and buttons on the page ---------- */
    function setText(id, txt) { var el = document.getElementById(id); if (el) el.textContent = txt; }
    function prices() {
      var total = packPrice(), was = variants[0].price * state.n, save = was - total;
      setText('zpp-now', money(total));
      setText('zpp-ctaprice', money(total));
      setText('zpp-sbprice', money(total));
      var wasEl = document.getElementById('zpp-was'), saveEl = document.getElementById('zpp-save');
      if (wasEl) { wasEl.textContent = money(was); wasEl.style.display = save > 0 ? '' : 'none'; }
      if (saveEl) { saveEl.textContent = (t.save || 'Save') + ' ' + money(save) + ' · −' + Math.round(save / was * 100) + '%'; saveEl.style.display = save > 0 ? '' : 'none'; }
    }
    function buttons() {
      var v = current(), ok = Boolean(v && v.available);
      ['zpp-add', 'zpp-sbadd', 'zpp-buynow'].forEach(function (id) { var b = document.getElementById(id); if (b) b.disabled = !ok; });
      showError(Boolean(v) && !ok);
    }

    /* ---------- gallery follows the chosen colour ---------- */
    function showImage(color) {
      var v = variants.find(function (x) { return x.color === color && x.image; });
      if (!v) return;
      var file = v.image.split('?')[0].split('/').pop().replace(/\.[a-z]+$/i, '');
      var thumbs = document.querySelectorAll('#zpp-thumbs .t');
      for (var i = 0; i < thumbs.length; i++) {
        if ((thumbs[i].getAttribute('data-full') || '').indexOf(file) >= 0) { thumbs[i].click(); return; }
      }
    }

    /* ---------- interaction ---------- */
    function selectPack(n) {
      state.n = n;
      fill(n);
      box.querySelectorAll('[data-zgs-pack]').forEach(function (b) {
        var on = Number(b.getAttribute('data-zgs-pack')) === n;
        b.classList.toggle('on', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      render();
    }
    function setPair(idx, color, size) {
      if (!variantOf(color, size)) size = firstAvailable(color).size;
      if (idx < 0) {
        state.allColor = color; state.allSize = size;
        state.pairs = state.pairs.map(function () { return { color: color, size: size }; });
      } else {
        state.pairs[idx] = { color: color, size: size };
        if (state.pairs.every(function (p) { return p.color === color && p.size === size; })) { state.allColor = color; state.allSize = size; }
      }
      render();
    }
    box.addEventListener('click', function (e) {
      var pack = e.target.closest('[data-zgs-pack]');
      if (pack) { selectPack(Number(pack.getAttribute('data-zgs-pack'))); return; }
      if (e.target.closest('[data-zgs-toggle]')) { state.open = !state.open; render(); return; }
      var sw = e.target.closest('.zgs-sw');
      if (sw && !sw.disabled) {
        var i = Number(sw.dataset.idx), cur = i < 0 ? { size: state.allSize } : state.pairs[i];
        var keepSize = variantOf(sw.dataset.color, cur.size) ? cur.size : firstAvailable(sw.dataset.color).size;
        setPair(i, sw.dataset.color, keepSize);
        if (i <= 0) showImage(sw.dataset.color);
        return;
      }
      var chip = e.target.closest('.zgs-chip');
      if (chip && !chip.disabled) {
        var j = Number(chip.dataset.idx), color = j < 0 ? state.allColor : state.pairs[j].color;
        setPair(j, color, chip.dataset.size);
      }
    });

    /* ---------- add to cart (takes over the page's own buttons) ---------- */
    function showError(on) { var el = pairsEl.querySelector('[data-zgs-error]'); if (el) { el.textContent = t.error; el.hidden = !on; } }
    function toast(msg) {
      var el = document.getElementById('zpp-toast'), m = document.getElementById('zpp-toastmsg');
      if (!el) return; if (m) m.textContent = msg; el.classList.add('show');
      clearTimeout(toast.h); toast.h = setTimeout(function () { el.classList.remove('show'); }, 2600);
    }
    var busy = false;
    function add(then) {
      var v = current();
      if (busy || !v) return; busy = true; showError(false);
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) })
        .then(function (r) {
          busy = false;
          if (!r.ok) { showError(true); return; }
          if (then === 'checkout') { window.location = root + 'checkout'; return; }
          toast(t.added + ' · ' + money(v.price));
          return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (c) { return c.json(); }).then(function (cart) {
            document.dispatchEvent(new CustomEvent('zorro:mysterybox:cart', { detail: cart }));
            var btn = document.getElementById('zpp-cartbtn'); if (btn) btn.click();
          });
        })
        .catch(function () { busy = false; showError(true); });
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest('#zpp-add, #zpp-sbadd, #zpp-buynow');
      if (!b) return;
      e.preventDefault(); e.stopImmediatePropagation();
      add(b.id === 'zpp-buynow' ? 'checkout' : 'drawer');
    }, true);

    fill(state.n);
    render();
    /* zorro-product.js loads after this script and sets its own price/buttons once */
    window.addEventListener('load', function () {
      prices(); buttons();
      if (start.color !== colors[0]) showImage(start.color);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zorro-language-switcher"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = () => {
      const forms = Array.from(document.querySelectorAll('.zorro-language-form'));
      if (!forms.length) return;
      const save = (storageName, key, value) => { try { window[storageName].setItem(key,value); } catch (_) {} };
      const read = (storageName, key) => { try { return window[storageName].getItem(key); } catch (_) { return null; } };
      forms.forEach(form => {
        if (form.dataset.languageReady) return;
        form.dataset.languageReady = 'true';
        form.querySelector('[data-zlanguage-return]').value = location.pathname + location.search + location.hash;
        form.addEventListener('submit', event => {
          const lang = event.submitter?.value;
          if (lang === 'fi' || lang === 'en') save('localStorage','zorro-language',lang);
          save('sessionStorage','zorro-language-checked','1');
        });
      });
      if (window.Shopify?.designMode || new URLSearchParams(location.search).has('preview_theme_id')) return;
      const current = document.documentElement.lang.split('-')[0];
      const preferred = read('localStorage','zorro-language');
      const alreadyChecked = read('sessionStorage','zorro-language-checked');
      if (!preferred && alreadyChecked) return;
      save('sessionStorage','zorro-language-checked','1');
      if (/\/(cart|checkout|account)(\/|$)/.test(location.pathname)) return;
      if (!preferred && document.referrer) { try { if (new URL(document.referrer).origin === location.origin) return; } catch (_) {} }
      const deviceLanguage = (navigator.languages?.[0] || navigator.language || 'en').toLowerCase().split('-')[0];
      const target = preferred === 'fi' || preferred === 'en' ? preferred : (deviceLanguage === 'fi' ? 'fi' : 'en');
      if (target !== current) {
        const button = forms[0].querySelector('button[value="'+target+'"]');
        if (button) forms[0].requestSubmit(button);
      }
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
    document.addEventListener('shopify:section:load',init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zorro-mystery-box"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.ZorroMysteryBox) return;
  var configNode = document.getElementById('zorro-mb-config');
  if (!configNode) return;
  var cfg;
  try { cfg = JSON.parse(configNode.textContent || '{}'); } catch (error) { return; }
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var BOX_VARIANT = Number(cfg.variant), BOX_PRODUCT = Number(cfg.product);
  if (!BOX_VARIANT || !BOX_PRODUCT) return;
  var GIFT_VARIANTS = (cfg.giftCardVariants || []).map(Number);
  var GIFT_PRODUCTS = (cfg.giftCardProducts || []).map(Number);
  var cartEnabled = !/(^|\/)password\/?$/.test(location.pathname);
  var remaining = Math.max(0, Number(cfg.stock) || 0);
  // The next batch opens at restockAt: until then no box is given and the bar
  // counts down; for 10 minutes after, it waits for the new stock to show.
  var RESTOCK_AT = Date.parse(cfg.restockAt || '') || 0;
  var canSellNow = cfg.available !== false;
  function gated() { return RESTOCK_AT > 0 && Date.now() < RESTOCK_AT; }
  function waiting() { return RESTOCK_AT > 0 && Date.now() < RESTOCK_AT + 600000 && (gated() || remaining === 0); }
  var available = canSellNow && remaining > 0 && !gated();
  var origFetch = window.fetch.bind(window);
  var JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var bar = document.querySelector('[data-zmb-bar]');
  var stockRequest = null, lastStockRead = 0, reconcileTimer = null;
  var reconcileChain = Promise.resolve(false);

  function measure() {
    var height = bar && !bar.hidden && getComputedStyle(bar).display !== 'none' ? bar.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty('--zorro-sale-bar-height', Math.round(height) + 'px');
  }
  // Cached responses can carry an older, higher stock. Boxes only run out,
  // so keep the lowest count seen in the last 30 minutes.
  var LOW_KEY = 'zmb-low-' + BOX_VARIANT;
  function lowest(quantity) {
    var count = Math.max(0, Math.floor(Number(quantity) || 0)), saved = null;
    try { saved = JSON.parse(localStorage.getItem(LOW_KEY) || 'null'); } catch (error) {}
    var fresh = saved && Date.now() - saved.t < 1800000;
    // A jump from sold out, or of more than 5, is a restock, not a stale cache.
    var restock = saved && (saved.n === 0 || count - saved.n > 5);
    if (fresh && !restock && saved.n < count) return saved.n;
    try { localStorage.setItem(LOW_KEY, JSON.stringify({ n: count, t: Date.now() })); } catch (error) {}
    return count;
  }
  // The counter starts 10 above the stock on the visitor's first page and
  // counts down one at a time, each gap 5 seconds longer than the last
  // (5, 10, 15 ... 50 s), then rests on the stock.
  var TICK_KEY = 'zmb-visit-start';
  var TICKS = [5000, 15000, 30000, 50000, 75000, 105000, 140000, 180000, 225000, 275000];
  var visitStart = Date.now();
  try {
    var savedStart = Number(sessionStorage.getItem(TICK_KEY));
    if (savedStart > 0 && savedStart <= visitStart) visitStart = savedStart;
    else sessionStorage.setItem(TICK_KEY, String(visitStart));
  } catch (error) {}
  var calm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var painted = false;
  function extra() {
    // The new batch is announced as exactly 20, so the real count is shown for the rest of that day (until 00:00 Finnish time).
    if (RESTOCK_AT && Date.now() < RESTOCK_AT + 21600000) return 0;
    var elapsed = Date.now() - visitStart;
    return TICKS.filter(function (at) { return elapsed < at; }).length;
  }
  function rollTo(node, from, to) {
    var pill = node.closest('.zmb-stock');
    node.dataset.n = to;
    node.setAttribute('aria-label', to);
    node.innerHTML = '<span class="zmb-roll" aria-hidden="true"><span>' + from + '</span><span>' + to + '</span></span>';
    if (pill) {
      pill.classList.remove('is-tick');
      void pill.offsetWidth;
      pill.classList.add('is-tick');
      var minus = document.createElement('i');
      minus.className = 'zmb-minus';
      minus.setAttribute('aria-hidden', 'true');
      minus.textContent = '\u2212' + (from - to);
      pill.appendChild(minus);
    }
    setTimeout(function () {
      if (node.dataset.n === String(to)) { node.textContent = String(to); node.removeAttribute('aria-label'); }
      if (minus) minus.remove();
      if (pill) pill.classList.remove('is-tick');
    }, 1300);
  }
  function paintStock() {
    var shown = remaining > 0 ? remaining + extra() : 0;
    document.querySelectorAll('[data-zmb-stock]').forEach(function (node) {
      var current = Number(node.dataset.n || node.textContent);
      if (current === shown && node.dataset.n) return;
      if (painted && !calm && shown < current && shown > 0) return rollTo(node, current, shown);
      node.dataset.n = shown;
      node.textContent = String(shown);
    });
    painted = true;
  }
  var tickTimer = setInterval(function () {
    paintStock();
    if (!extra()) clearInterval(tickTimer);
  }, 250);
  function setStock(quantity, canSell) {
    var wasAvailable = available;
    remaining = lowest(quantity);
    canSellNow = canSell !== false;
    available = canSellNow && remaining > 0 && !gated();
    cfg.stock = remaining;
    cfg.available = available;
    paintStock();
    document.documentElement.toggleAttribute('data-zmb-soldout', !available);
    if (bar) {
      var wait = waiting();
      bar.classList.toggle('is-drop-wait', wait);
      bar.hidden = !available && !wait;
    }
    measure();
    if (cartEnabled && wasAvailable !== available) queueReconcile();
  }
  function refreshStock(force) {
    if (stockRequest) return stockRequest;
    if (!force && Date.now() - lastStockRead < 2000) return Promise.resolve(remaining);
    var url = new URL(location.href);
    url.hash = '';
    url.searchParams.delete('section_id');
    url.searchParams.set('sections', 'zorro-mystery-stock');
    url.searchParams.set('_zmb', String(Date.now()));
    function readState(html) {
      if (typeof html !== 'string') throw new Error('stock');
      var page = new DOMParser().parseFromString(html, 'text/html');
      var node = page.getElementById('zorro-mb-config');
      if (!node) throw new Error('stock');
      var state = JSON.parse(node.textContent);
      if (Number(state.variant) !== BOX_VARIANT || !Number.isFinite(Number(state.stock))) throw new Error('stock');
      return state;
    }
    stockRequest = origFetch(url.toString(), { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (response) { if (!response.ok) throw new Error('stock'); return response.json(); })
      .then(function (sections) { return readState(sections['zorro-mystery-stock']); })
      .catch(function () {
        // Password-protected stores can reject the Section Rendering API.
        // Read the same public page instead; Liquid still supplies the real stock.
        url.searchParams.delete('sections');
        return origFetch(url.toString(), { cache: 'no-store', headers: { Accept: 'text/html' } })
          .then(function (response) { if (!response.ok) throw new Error('stock'); return response.text(); })
          .then(readState);
      })
      .then(function (state) {
        lastStockRead = Date.now();
        setStock(Number(state.stock), state.available);
        return remaining;
      })
      .catch(function () { return remaining; })
      .then(function (quantity) { stockRequest = null; return quantity; });
    return stockRequest;
  }
  function isBoxItem(item) {
    return Number(item.variant_id) === BOX_VARIANT || Number(item.product_id) === BOX_PRODUCT;
  }
  function isMerchandise(item) {
    return !isBoxItem(item) && item.gift_card !== true &&
      GIFT_PRODUCTS.indexOf(Number(item.product_id)) < 0 &&
      GIFT_VARIANTS.indexOf(Number(item.variant_id)) < 0 &&
      Number(item.quantity) > 0;
  }
  function boxLine() {
    return { id: BOX_VARIANT, quantity: 1, properties: { _zorro_gift: 'mystery-box' } };
  }
  function getCart() {
    return origFetch(root + 'cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (response) { if (!response.ok) throw new Error(cfg.checkoutError); return response.json(); });
  }
  function changeLine(key, quantity) {
    return origFetch(root + 'cart/change.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ id: key, quantity: quantity }) })
      .then(function (response) { if (!response.ok) throw new Error(cfg.checkoutError); return true; });
  }
  function addBox() {
    return origFetch(root + 'cart/add.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ items: [boxLine()] }) })
      .then(function (response) {
        if (response.ok) return true;
        // The storefront stock lags the real one, so a failed add usually means
        // the boxes ran out. Never block checkout over the free box.
        if (response.status === 422) setStock(0, false);
        return false;
      });
  }
  function publishCart(cart) {
    document.dispatchEvent(new CustomEvent('zorro:mysterybox:cart', { detail: cart }));
    if (window.ZorroCampaign && window.ZorroCampaign.updateCart) window.ZorroCampaign.updateCart(cart);
  }
  function runReconcile() {
    return getCart().then(function (cart) {
      var items = cart.items || [], boxes = items.filter(isBoxItem), operations = [];
      var wantBox = available && items.some(isMerchandise);
      if (!wantBox) {
        boxes.forEach(function (item) { operations.push(function () { return changeLine(item.key, 0); }); });
      } else {
        if (!boxes.length) operations.push(addBox);
        boxes.forEach(function (item, index) {
          if (index > 0) operations.push(function () { return changeLine(item.key, 0); });
          else if (item.quantity !== 1) operations.push(function () { return changeLine(item.key, 1); });
        });
      }
      return operations.reduce(function (chain, operation) {
        return chain.then(function (changed) {
          return operation().then(function (result) { return changed || result; });
        });
      }, Promise.resolve(false));
    }).then(function (changed) {
      if (!changed) return false;
      return getCart().then(function (cart) { publishCart(cart); return true; });
    });
  }
  function reconcile() {
    if (!cartEnabled) return Promise.resolve(false);
    reconcileChain = reconcileChain.catch(function () {}).then(runReconcile);
    return reconcileChain;
  }
  function queueReconcile() {
    if (!cartEnabled) return;
    clearTimeout(reconcileTimer);
    reconcileTimer = setTimeout(function () { reconcile().catch(function () {}); }, 120);
  }
  function bodyItems(body) {
    if (!body || typeof body !== 'object') return null;
    if (Array.isArray(body.items)) return body.items.map(function (item) { return Object.assign({}, item); });
    if (body.id !== undefined) return [{ id: body.id, quantity: body.quantity === undefined ? 1 : body.quantity, properties: body.properties, selling_plan: body.selling_plan }];
    return null;
  }
  if (cartEnabled) window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (!/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) return origFetch(input, init);
    var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
    if (isAdd && available && init && typeof init.body === 'string') {
      var parsed;
      try { parsed = JSON.parse(init.body); } catch (error) {}
      var items = bodyItems(parsed);
      var qualifies = items && items.some(function (item) {
        return Number(item.quantity === undefined ? 1 : item.quantity) > 0 && Number(item.id) !== BOX_VARIANT && GIFT_VARIANTS.indexOf(Number(item.id)) < 0;
      });
      var hasBox = items && items.some(function (item) { return Number(item.id) === BOX_VARIANT; });
      if (qualifies && !hasBox) {
        items.push(boxLine());
        var payload = Object.assign({}, parsed, { items: items });
        ['id', 'quantity', 'properties', 'selling_plan'].forEach(function (key) { delete payload[key]; });
        var combined = Object.assign({}, init, { body: JSON.stringify(payload) });
        return origFetch(input, combined).then(function (response) {
          if (response.ok) { queueReconcile(); return response; }
          return origFetch(input, init).then(function (originalResponse) {
            refreshStock(true);
            queueReconcile();
            return originalResponse;
          });
        });
      }
    }
    return origFetch(input, init).then(function (response) { queueReconcile(); return response; });
  };

  function checkoutError(trigger) {
    var node = document.getElementById('zmb-cart-error');
    if (!node) {
      node = document.createElement('p');
      node.id = 'zmb-cart-error';
      node.className = 'zmb-cart-error';
      node.setAttribute('role', 'alert');
      var host = document.querySelector('.zcart-summary') || (trigger && trigger.closest('.drawer-foot,.zd-foot,.drawer__footer')) || document.body;
      host.appendChild(node);
    }
    node.textContent = cfg.checkoutError;
  }
  var checkoutBusy = false;
  function checkout(url, trigger, updates) {
    if (checkoutBusy) return;
    checkoutBusy = true;
    if (trigger && trigger.tagName === 'BUTTON') trigger.disabled = true;
    var error = document.getElementById('zmb-cart-error');
    if (error) error.textContent = '';
    var update = updates ? origFetch(root + 'cart/update.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ updates: updates }) })
      .then(function (response) { if (!response.ok) throw new Error(cfg.checkoutError); }) : Promise.resolve();
    return update.then(function () { return refreshStock(true); })
      .then(reconcile)
      .then(function () { location.assign(url); })
      .catch(function () { checkoutError(trigger); })
      .then(function () { checkoutBusy = false; if (trigger && trigger.tagName === 'BUTTON') trigger.disabled = false; });
  }
  if (cartEnabled) {
    document.addEventListener('click', function (event) {
      if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var link = event.target.closest('a[href]');
      if (!link) return;
      var url;
      try { url = new URL(link.href, location.href); } catch (error) { return; }
      if (url.origin !== location.origin || !/\/checkout\/?$/.test(url.pathname)) return;
      event.preventDefault();
      checkout(url.toString(), link);
    }, true);
    var cartForm = document.querySelector('.zcart-form');
    if (cartForm) cartForm.addEventListener('submit', function (event) {
      var updates = {}, hasMerchandise = false, boxes = [];
      cartForm.querySelectorAll('.zcart-line').forEach(function (line) {
        var input = line.querySelector('input[name="updates[]"]');
        if (!input) return;
        var quantity = Math.max(0, parseInt(input.value, 10) || 0);
        var productId = Number(line.getAttribute('data-product-id'));
        var key = line.getAttribute('data-line-key');
        if (key) updates[key] = quantity;
        if (productId === BOX_PRODUCT) boxes.push(input);
        else if (line.getAttribute('data-gift-card') !== 'true' && GIFT_PRODUCTS.indexOf(productId) < 0 && quantity > 0) hasMerchandise = true;
      });
      if (!hasMerchandise || !available) boxes.forEach(function (input) { input.value = 0; });
      var submitter = event.submitter;
      if (!submitter || submitter.name !== 'checkout') return;
      event.preventDefault();
      checkout(root + 'checkout', submitter, updates);
    });
  }

  function relabel() {
    document.querySelectorAll('.zcart-gift').forEach(function (node) {
      if (node.textContent !== cfg.cartLabel) node.textContent = cfg.cartLabel;
    });
  }
  if (window.MutationObserver) {
    ['zpp-dbody', 'zcart-body'].forEach(function (id) {
      var node = document.getElementById(id);
      if (node) new MutationObserver(relabel).observe(node, { childList: true, subtree: true });
    });
  }
  setStock(remaining, cfg.available);
  measure();
  if (RESTOCK_AT) {
    var timerNodes = document.querySelectorAll('[data-zmb-timer]');
    var waitTimer = setInterval(function () {
      var left = RESTOCK_AT - Date.now();
      var text = '00:00:00';
      if (left > 0) {
        var s = Math.ceil(left / 1000);
        text = [Math.floor(s / 3600), Math.floor(s / 60) % 60, s % 60].map(function (n) { return n < 10 ? '0' + n : String(n); }).join(':');
      }
      timerNodes.forEach(function (node) { if (node.textContent !== text) node.textContent = text; });
      if (left <= 0) {
        if (available || !waiting()) { clearInterval(waitTimer); setStock(remaining, canSellNow); }
        else if (Math.floor(-left / 1000) % 5 === 0) refreshStock(true);
        if (!available && left > -1500) setStock(remaining, canSellNow);
      }
    }, 1000);
  }
  if (bar && window.ResizeObserver) new ResizeObserver(measure).observe(bar);
  window.addEventListener('resize', measure);
  window.addEventListener('load', measure);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) refreshStock(true).then(queueReconcile); });
  window.addEventListener('focus', function () { refreshStock(true).then(queueReconcile); });
  setInterval(function () { if (!document.hidden) refreshStock(false).then(queueReconcile); }, 15000);
  window.ZorroMysteryBox = { version: 'stock-1', reconcile: reconcile, refreshStock: refreshStock, config: cfg };
  refreshStock(true).then(function () {
    if (!cartEnabled) return false;
    return reconcile().then(function (changed) {
      if (changed && /\/cart\/?$/.test(location.pathname)) location.reload();
    });
  }).catch(function () {});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zorro-product-carousel"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = (scope) => {
      scope.querySelectorAll('[data-zproduct-nav]').forEach((nav) => {
        if (nav.dataset.ready) return;
        const track = document.getElementById(nav.dataset.zproductNav);
        if (!track) return;
        const cards = Array.from(track.children).filter((el) => el.classList.contains('pcard'));
        if (!cards.length) { nav.hidden = true; return; }
        nav.dataset.ready = 'true';
        const prev = nav.querySelector('[data-zproduct-prev]');
        const next = nav.querySelector('[data-zproduct-next]');
        const count = nav.querySelector('[data-zproduct-count]');
        const mobile = window.matchMedia('(max-width: 767px)');
        const positions = () => {
          const start = track.getBoundingClientRect().left;
          const max = track.scrollWidth - track.clientWidth;
          return cards.map((card) => Math.min(max, Math.max(0, card.getBoundingClientRect().left - start + track.scrollLeft)));
        };
        const current = () => {
          const offsets = positions();
          return offsets.reduce((best, value, i) => Math.abs(value - track.scrollLeft) < Math.abs(offsets[best] - track.scrollLeft) ? i : best, 0);
        };
        const sync = () => {
          const i = current();
          count.textContent = `${i + 1} / ${cards.length}`;
          prev.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
        };
        const move = (direction) => {
          if (!mobile.matches) return;
          const i = Math.max(0, Math.min(cards.length - 1, current() + direction));
          track.scrollTo({ left: positions()[i], behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        };
        prev.addEventListener('click', () => move(-1));
        next.addEventListener('click', () => move(1));
        track.addEventListener('scroll', sync, { passive: true });
        track.addEventListener('keydown', (event) => {
          if (event.target !== track || !mobile.matches) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            move(event.key === 'ArrowRight' ? 1 : -1);
          }
        });
        mobile.addEventListener('change', sync);
        window.addEventListener('resize', sync, { passive: true });
        sync();
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
    else init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zorro-snap-carousel"] && !Shopify.designMode) return;
  try {
    (function(){
    function init(sc){
      if(sc.__zsnap)return;sc.__zsnap=true;
      var track=sc.querySelector('[data-zsnap-track]'),prev=sc.querySelector('[data-zsnap-prev]'),next=sc.querySelector('[data-zsnap-next]'),dots=sc.querySelector('[data-zsnap-dots]'),raf=0;
      if(!track)return;
      function cards(){return [].slice.call(track.children);}
      function step(){var c=cards();return c.length>1?c[1].offsetLeft-c[0].offsetLeft:track.clientWidth||1;}
      function perView(){return Math.max(1,Math.round(track.clientWidth/step()));}
      function positions(){return Math.max(1,cards().length-perView()+1);}
      function idx(){return Math.min(positions()-1,Math.round(track.scrollLeft/step()));}
      function go(i){track.scrollTo({left:Math.max(0,Math.min(i,positions()-1))*step(),behavior:'smooth'});}
      function buildDots(){
        if(!dots)return;var n=positions();if(dots.children.length===n)return;
        dots.innerHTML='';
        for(var k=0;k<n;k++){var b=document.createElement('button');b.type='button';b.setAttribute('role','tab');b.setAttribute('aria-label',(k+1)+' / '+n);b.addEventListener('click',go.bind(null,k));dots.appendChild(b);}
      }
      function sync(){
        buildDots();
        var i=idx(),can=positions()>1,max=track.scrollWidth-track.clientWidth-2;
        sc.classList.toggle('is-scrollable',can);
        if(prev)prev.disabled=track.scrollLeft<=2;
        if(next)next.disabled=track.scrollLeft>=max;
        if(dots){dots.hidden=!can;[].forEach.call(dots.children,function(d,k){d.classList.toggle('on',k===i);d.setAttribute('aria-selected',k===i);});}
      }
      function queue(){cancelAnimationFrame(raf);raf=requestAnimationFrame(sync);}
      if(prev)prev.addEventListener('click',function(){go(idx()-1);});
      if(next)next.addEventListener('click',function(){go(idx()+1);});
      // scroll is high-frequency, so it is coalesced per frame; everything else
      // syncs directly so a throttled rAF (background tab) cannot leave stale state
      track.addEventListener('scroll',queue,{passive:true});
      window.addEventListener('resize',sync);
      window.addEventListener('load',sync);
      if(window.ResizeObserver)new ResizeObserver(sync).observe(track);
      if(window.MutationObserver)new MutationObserver(sync).observe(track,{childList:true});
      sync();
    }
    function initAll(){document.querySelectorAll('[data-zsnap]').forEach(init);}
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAll);else initAll();
    document.addEventListener('shopify:section:load',initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zorro-socks-bundle"] && !Shopify.designMode) return;
  try {
    (function () {
    var box = document.querySelector('#zorro-pp [data-zsb]');
    if (!box || box.dataset.ready) return;
    box.dataset.ready = '1';

    function json(sel, fallback) { var el = box.querySelector(sel); try { return JSON.parse(el.textContent); } catch (e) { return fallback; } }
    var single = json('[data-zgs-tiers]', [])[0];
    var data = json('[data-zsb-data]', {});
    var t = json('[data-zgs-copy]', {});
    var unit = Number(box.dataset.sleeveUnit) || 0, sleevePrice = Number(box.dataset.sleevePrice) || unit;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var pairsEl = box.querySelector('[data-zgs-pairs]'), sleevesEl = box.querySelector('[data-zsb-sleeves]'), errEl = box.querySelector('[data-zsb-error]');
    if (!single || !single.variants || !data.sleeves) return;
    var variants = single.variants;

    var colors = [];
    variants.forEach(function (v) { if (colors.indexOf(v.color) < 0) colors.push(v.color); });
    var sleeveColors = data.sleeves.map(function (s) { return s.color; });
    function sizesOf(color) { return variants.filter(function (v) { return v.color === color; }); }
    function variantOf(color, size) { return variants.find(function (v) { return v.color === color && v.size === size; }); }
    function colorKey(c) { var s = String(c || '').toLowerCase(); return /black|must/.test(s) ? 'black' : /blue|sinin/.test(s) ? 'blue' : /red|puna/.test(s) ? 'red' : 'white'; }
    function colorName(c) { return t[colorKey(c)] || c; }
    function sizeShort(size) { var m = /^(.+?)\s*\((.+)\)$/.exec(size || ''); return m ? { a: m[1], b: m[2] } : { a: size, b: '' }; }
    function firstAvailable(color) { var list = sizesOf(color); return list.find(function (v) { return v.available; }) || list[0]; }
    function money(cents) { return '€' + (cents / 100).toFixed(2).replace('.', ','); }

    /* option values look like "2× White S + 1× Black One size"; match on counts, not order */
    function key(counts) { return Object.keys(counts).sort().map(function (k) { return counts[k] + '×' + k; }).join('|'); }
    function parse(title) {
      var counts = {};
      String(title).split(' + ').forEach(function (part) { var m = /^(\d+)\s*×\s*(.+)$/.exec(part.trim()); if (m) counts[m[2]] = Number(m[1]); });
      return key(counts);
    }
    function optionId(k, optName, counts) {
      var b = data.bundles && data.bundles[k]; if (!b || !b.options[optName]) return null;
      var want = key(counts), vals = b.options[optName];
      for (var name in vals) { if (parse(name) === want) return { id: vals[name], name: name }; }
      return null;
    }

    var start = variants.find(function (v) { return v.available; }) || variants[0];
    var firstSleeve = data.sleeves.find(function (s) { return s.available; }) || data.sleeves[0];
    var state = { n: 1, pairs: [{ color: start.color, size: start.size }], k: 1, sleeves: [firstSleeve.color] };

    function gripCounts() {
      var c = {};
      state.pairs.forEach(function (p) { var l = p.color + ' ' + sizeShort(p.size).a; c[l] = (c[l] || 0) + 1; });
      return c;
    }
    function sleeveCounts() { var c = {}; state.sleeves.forEach(function (s) { c[s] = (c[s] || 0) + 1; }); return c; }
    function total() { return (data.grip[state.n] || 0) + unit * state.k; }

    /* ---------- render ---------- */
    function swatches(kind, idx, list, cur, availableOf) {
      var named = kind === 's';
      return '<div class="' + (named ? 'zsb-colors' : 'zgs-colors') + '" role="radiogroup" aria-label="' + t.pairLabel + ' ' + (idx + 1) + '">' +
        list.map(function (c) {
          var ok = availableOf(c);
          return '<button type="button" class="zgs-sw' + (named ? ' zsb-cpill' : '') + (c === cur ? ' on' : '') + '" data-kind="' + kind + '" data-idx="' + idx + '" data-color="' + c + '" role="radio" aria-checked="' + (c === cur) + '" aria-label="' + colorName(c) + (ok ? '' : ' · ' + t.soldOut) + '"' + (ok ? '' : ' disabled') + '><span class="dot dot--' + colorKey(c) + '"></span>' + (named ? colorName(c) : '') + '</button>';
        }).join('') + '</div>';
    }
    function chips(idx, color, cur) {
      var list = sizesOf(color);
      return '<div class="zgs-sizes">' + list.map(function (v) {
        var s = sizeShort(v.size), only = list.length === 1;
        return '<button type="button" class="zgs-chip' + (v.size === cur ? ' on' : '') + (only ? ' is-only' : '') + '" data-idx="' + idx + '" data-size="' + v.size + '" aria-pressed="' + (v.size === cur) + '"' + (v.available ? '' : ' disabled') + '>' + s.a + (s.b ? ' <small>' + s.b + '</small>' : '') + '</button>';
      }).join('') + '</div>';
    }
    function gripAvail(c) { return sizesOf(c).some(function (v) { return v.available; }); }
    function sleeveAvail(c) { var s = data.sleeves.find(function (x) { return x.color === c; }); return Boolean(s && s.available); }
    function render() {
      var html = '<div class="zgs-pairs-head"><b>' + state.n + ' × ' + t.pairsHead + '</b></div><ul class="zgs-rows">';
      state.pairs.forEach(function (p, i) {
        html += '<li class="zgs-row"><span class="zgs-row-label">' + t.pairLabel + ' ' + (i + 1) + '</span>' + swatches('g', i, colors, p.color, gripAvail) + chips(i, p.color, p.size) + '</li>';
      });
      pairsEl.innerHTML = html + '</ul>';
      var sh = '<div class="zgs-pairs-head"><b>' + state.k + ' × ' + t.sleevesHead + '</b></div><ul class="zgs-rows">';
      state.sleeves.forEach(function (c, i) {
        sh += '<li class="zgs-row zsb-srow"><span class="zgs-row-label">' + t.pairLabel + ' ' + (i + 1) + '</span>' + swatches('s', i, sleeveColors, c, sleeveAvail) + '</li>';
      });
      sleevesEl.innerHTML = sh + '</ul>';
      prices();
      resolve();
    }

    /* ---------- prices on the page ---------- */
    function setText(id, txt) { var el = document.getElementById(id); if (el) el.textContent = txt; }
    function prices() {
      var sum = total(), was = variants[0].price * state.n + sleevePrice * state.k, save = was - sum;
      setText('zpp-now', money(sum)); setText('zpp-ctaprice', money(sum)); setText('zpp-sbprice', money(sum));
      var wasEl = document.getElementById('zpp-was'), saveEl = document.getElementById('zpp-save');
      if (wasEl) { wasEl.textContent = money(was); wasEl.style.display = save > 0 ? '' : 'none'; }
      if (saveEl) { saveEl.textContent = (t.save || 'Save') + ' ' + money(save) + ' · −' + Math.round(save / was * 100) + '%'; saveEl.style.display = save > 0 ? '' : 'none'; }
      var pill = document.querySelector('#zorro-pp .pill-disc'); if (pill && save > 0) pill.textContent = '−' + Math.round(save / was * 100) + '%';
      function count(n) { return n + ' ' + (n === 1 ? t.pair : t.pairs); }
      box.querySelector('[data-zsb-sum]').innerHTML =
        '<div><span>' + t.gripLine + ' · ' + count(state.n) + '</span><span>' + money(data.grip[state.n] || 0) + '</span></div>' +
        '<div><span>' + t.sleeveLine + ' · ' + count(state.k) + '</span><span>' + money(unit * state.k) + '</span></div>' +
        '<div class="zsb-sum-total"><span>' + t.totalLine + '</span><span>' + money(sum) + '</span></div>';
    }

    /* ---------- find the bundle variant for the current picks ---------- */
    var cache = {}, chosen = null, seq = 0;
    function setButtons(ok) { ['zpp-add', 'zpp-sbadd', 'zpp-buynow'].forEach(function (id) { var b = document.getElementById(id); if (b) b.disabled = !ok; }); }
    function showError(on) { errEl.textContent = t.error; errEl.hidden = !on; }
    function resolve() {
      chosen = null; setButtons(false); showError(false);
      var g = optionId(state.k, 'Gripsocks', gripCounts()), s = optionId(state.k, 'Sleeves', sleeveCounts());
      if (!g || !s) { showError(true); return; }
      var b = data.bundles[state.k], url = root + 'products/' + b.handle + '?view=zgs-variant&option_values=' + g.id + ',' + s.id, my = ++seq;
      var p = cache[url] || (cache[url] = fetch(url).then(function (r) { return r.json(); }));
      p.then(function (v) {
        if (my !== seq) return;
        var ok = v && v.title === g.name + ' / ' + s.name;
        chosen = ok ? v : null;
        setButtons(Boolean(ok && v.available));
        showError(!ok || !v.available);
      }).catch(function () { if (my === seq) { delete cache[url]; showError(true); } });
    }

    /* ---------- gallery follows the first pair's colour ---------- */
    function showImage(color) {
      var v = variants.find(function (x) { return x.color === color && x.image; });
      if (!v) return;
      var file = v.image.split('?')[0].split('/').pop().replace(/\.[a-z]+$/i, '');
      var thumbs = document.querySelectorAll('#zpp-thumbs .t');
      for (var i = 0; i < thumbs.length; i++) { if ((thumbs[i].getAttribute('data-full') || '').indexOf(file) >= 0) { thumbs[i].click(); return; } }
    }

    /* ---------- interaction ---------- */
    function pick(selector, attr, value) {
      box.querySelectorAll(selector).forEach(function (b) { var on = b.getAttribute(attr) === String(value); b.classList.toggle('on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
    }
    box.addEventListener('click', function (e) {
      var pack = e.target.closest('[data-zgs-pack]');
      if (pack) {
        state.n = Number(pack.getAttribute('data-zgs-pack'));
        var keep = state.pairs.slice(0, state.n), last = keep[keep.length - 1];
        while (keep.length < state.n) keep.push({ color: last.color, size: last.size });
        state.pairs = keep; pick('[data-zgs-pack]', 'data-zgs-pack', state.n); render(); return;
      }
      var cnt = e.target.closest('[data-zsb-count]');
      if (cnt) {
        state.k = Number(cnt.getAttribute('data-zsb-count'));
        var ks = state.sleeves.slice(0, state.k);
        while (ks.length < state.k) ks.push(ks[ks.length - 1]);
        state.sleeves = ks; pick('[data-zsb-count]', 'data-zsb-count', state.k); render(); return;
      }
      var sw = e.target.closest('.zgs-sw');
      if (sw && !sw.disabled) {
        var i = Number(sw.dataset.idx);
        if (sw.dataset.kind === 's') { state.sleeves[i] = sw.dataset.color; render(); return; }
        var cur = state.pairs[i], size = variantOf(sw.dataset.color, cur.size) ? cur.size : firstAvailable(sw.dataset.color).size;
        state.pairs[i] = { color: sw.dataset.color, size: size }; render();
        if (i === 0) showImage(sw.dataset.color);
        return;
      }
      var chip = e.target.closest('.zgs-chip[data-size]');
      if (chip && !chip.disabled) { var j = Number(chip.dataset.idx); state.pairs[j] = { color: state.pairs[j].color, size: chip.dataset.size }; render(); }
    });

    /* ---------- add to cart (takes over the page's own buttons) ---------- */
    function toast(msg) {
      var el = document.getElementById('zpp-toast'), m = document.getElementById('zpp-toastmsg');
      if (!el) return; if (m) m.textContent = msg; el.classList.add('show');
      clearTimeout(toast.h); toast.h = setTimeout(function () { el.classList.remove('show'); }, 2600);
    }
    var busy = false;
    function add(then) {
      var v = chosen;
      if (busy || !v) return; busy = true; showError(false);
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) })
        .then(function (r) {
          busy = false;
          if (!r.ok) { showError(true); return; }
          if (then === 'checkout') { window.location = root + 'checkout'; return; }
          toast(t.added + ' · ' + money(v.price));
          return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (c) { return c.json(); }).then(function (cart) {
            document.dispatchEvent(new CustomEvent('zorro:mysterybox:cart', { detail: cart }));
            var btn = document.getElementById('zpp-cartbtn'); if (btn) btn.click();
          });
        })
        .catch(function () { busy = false; showError(true); });
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest('#zpp-add, #zpp-sbadd, #zpp-buynow');
      if (!b) return;
      e.preventDefault(); e.stopImmediatePropagation();
      add(b.id === 'zpp-buynow' ? 'checkout' : 'drawer');
    }, true);

    render();
    /* zorro-product.js loads after this script and sets its own price/buttons once */
    window.addEventListener('load', function () { prices(); setButtons(Boolean(chosen && chosen.available)); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zorro-story-video"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-zorro-story]').forEach(function (story) {
    var preview = story.querySelector('[data-zorro-story-preview]');
    var openButton = story.querySelector('[data-zorro-story-open]');
    var dialog = story.querySelector('[data-zorro-story-dialog]');
    var fullVideo = story.querySelector('[data-zorro-story-full]');
    var closeButton = story.querySelector('[data-zorro-story-close]');

    if (!preview || !openButton || !dialog || !fullVideo || !closeButton) return;

    var closeStory = function () {
      fullVideo.pause();
      if (dialog.open) dialog.close();
      preview.currentTime = fullVideo.currentTime || 0;
      preview.muted = true;
      preview.play().catch(function () {});
    };

    openButton.addEventListener('click', function () {
      preview.pause();
      fullVideo.currentTime = preview.currentTime || 0;
      fullVideo.muted = false;
      dialog.showModal();
      fullVideo.play().catch(function () {});
    });

    closeButton.addEventListener('click', closeStory);
    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      closeStory();
    });
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closeStory();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
